import classNames from 'classnames';
import t__default from 'react';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';

var css_248z = ".vk65q{display:inline-block;height:23px;opacity:.6;position:relative;width:45px}.vk65q:hover{opacity:1}[dir] .vk65q:hover{cursor:pointer}._2Rts-{opacity:1}._2Rts-:hover{opacity:.6}.yXDhc{-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;display:flex;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[dir=ltr] .yXDhc{margin-left:auto}[dir=rtl] .yXDhc{margin-right:auto}.ejijx{align-items:center;display:flex;height:100%;pointer-events:none;position:absolute;top:0;width:100%}[dir=ltr] .ejijx{left:0}[dir=rtl] .ejijx{right:0}.Yz-bq{flex:1;height:100%}[dir] .Yz-bq{background-color:rgba(0,0,0,.6);border-radius:12px}[dir] .l3uI3{background-color:var(--ricos-settings-action-color,var(--ricos-action-color,#116dff))}.Yz-bq svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.G8RL4{height:21px;position:absolute;transition:transform .3s;width:22px}[dir] .G8RL4{background-color:#fff;border-radius:50%}[dir=ltr] .FGubH{transform:translateX(22px)}[dir=rtl] .FGubH{transform:translateX(-22px)}[dir=ltr] .NYdAW{transform:translateX(1px)}[dir=rtl] .NYdAW{transform:translateX(-1px)}";
var styles = {"toggle_input_container":"vk65q","toggle_input_container_checked":"_2Rts-","toggle_input_root":"yXDhc","toggle_switch":"ejijx","toggle_track":"Yz-bq","toggle_track_checked":"l3uI3","toggle_slider":"G8RL4","toggle_slider_checked":"FGubH","toggle_slider_unchecked":"NYdAW"};
styleInject(css_248z);

const Toggle = ({ checked, onChange, dataHook }) => {
  return /* @__PURE__ */ t__default.createElement(
    "div",
    {
      className: styles.toggle_input_root,
      onClick: onChange,
      tabIndex: -1,
      onKeyPress: void 0,
      role: "button",
      "data-hook": dataHook
    },
    /* @__PURE__ */ t__default.createElement(
      "div",
      {
        className: classNames(styles.toggle_input_container, {
          [styles.toggle_input_container_checked]: checked
        })
      },
      /* @__PURE__ */ t__default.createElement("div", { className: styles.toggle_switch }, /* @__PURE__ */ t__default.createElement(
        "span",
        {
          className: classNames(styles.toggle_track, {
            [styles.toggle_track_checked]: checked
          })
        }
      ), /* @__PURE__ */ t__default.createElement(
        "span",
        {
          className: classNames(
            styles.toggle_slider,
            checked ? styles.toggle_slider_checked : styles.toggle_slider_unchecked
          )
        }
      ))
    )
  );
};

export { Toggle as default };
//# sourceMappingURL=Toggle.js.map
